import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  makeTaxpayerSelectors,
  useDeleteTaxpayerMutation,
} from '../taxpayersApiSlice'

const TaxPayerRow = ({ taxpayerId, queryArgs }) => {
  const taxpayersSelectors = useMemo(
    () => makeTaxpayerSelectors(queryArgs),
    [queryArgs]
  )

  const taxpayer = useSelector((state) =>
    taxpayersSelectors.selectTaxpayerById(state, String(taxpayerId))
  )

  const [deleteTaxpayer, { isLoading: isDeleting }] =
    useDeleteTaxpayerMutation()

  if (!taxpayer) return null

  const handleDelete = async () => {
    const confirmed = window.confirm(
      `Delete taxpayer "${taxpayer.full_name || taxpayer.taxpayer_id}"?`
    )

    if (!confirmed) return

    try {
      await deleteTaxpayer({ id: taxpayerId }).unwrap()
    } catch (err) {
      alert(err?.data?.message || err?.error || 'Failed to delete taxpayer.')
    }
  }

  return (
    <tr className="hover:bg-slate-50">
      <td className="whitespace-nowrap px-4 py-3 font-medium text-slate-800">
        {taxpayer.taxpayer_id ?? taxpayer.id}
      </td>

      <td className="px-4 py-3">
        {taxpayer.full_name || '-'}
      </td>

      <td className="px-4 py-3">
        {taxpayer.nick_name || '-'}
      </td>

      <td className="px-4 py-3">
        {taxpayer.npwp || '-'}
      </td>

      <td className="px-4 py-3">
        {taxpayer.nik || '-'}
      </td>

      <td className="px-4 py-3">
        {taxpayer.email || '-'}
      </td>

      <td className="px-4 py-3">
        {taxpayer.phone_number || '-'}
      </td>

      <td className="px-4 py-3">
        {taxpayer.nationality || '-'}
      </td>

      <td className="whitespace-nowrap px-4 py-3">
        <div className="flex flex-wrap items-center gap-2">
          <Link
            to={`/dash/taxpayers/${taxpayerId}`}
            className="inline-flex items-center justify-center rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-medium text-slate-700 transition hover:bg-slate-50"
          >
            Detail
          </Link>

          <Link
            to={`/dash/taxpayers/edit/${taxpayerId}`}
            className="inline-flex items-center justify-center rounded-lg border border-blue-300 px-3 py-1.5 text-xs font-medium text-blue-700 transition hover:bg-blue-50"
          >
            Edit
          </Link>

          <button
            type="button"
            onClick={handleDelete}
            disabled={isDeleting}
            className="inline-flex items-center justify-center rounded-lg border border-red-300 px-3 py-1.5 text-xs font-medium text-red-700 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </td>
    </tr>
  )
}

export default TaxPayerRow